import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Truck } from "@/components/icons";
import { publicApi } from "@/lib/api";
import { FaultStatusBadge } from "@/components/Badges";
import { Card } from "@/components/ui/card";

// Public status-only follow page. Shows ONLY status + a public note -- never
// internal names, notes, assignments or reporter contact.
export default function PublicFollow() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const res = await publicApi.get(`/public/follow/${token}`);
        setData(res.data);
      } catch (e) { setNotFound(true); }
      finally { setLoading(false); }
    })();
  }, [token]);

  return (
    <div className="min-h-screen bg-muted/30 px-4 py-6">
      <div className="mx-auto w-full max-w-md">
        <div className="mb-4 flex items-center gap-2">
          <div className="flex h-9 w-9 items-center justify-center rounded-md bg-primary text-primary-foreground"><Truck size={18} /></div>
          <div className="leading-tight"><div className="text-body font-semibold">TD-Ops</div><div className="text-data text-muted-foreground">Status van je melding</div></div>
        </div>
        {loading && <Card className="p-6 text-center text-body text-muted-foreground">Laden...</Card>}
        {notFound && !loading && <Card className="p-6 text-center text-body text-foreground">Deze volglink is onbekend.</Card>}
        {data && (
          <Card className="space-y-3 p-6" data-testid="public-follow">
            <div className="font-mono text-body text-muted-foreground">{data.fault_number}</div>
            <div><FaultStatusBadge status={data.status} /></div>
            <p className="text-body text-foreground" data-testid="public-follow-note">{data.public_note}</p>
          </Card>
        )}
      </div>
    </div>
  );
}
